export default "__VITE_ASSET__5dedeb21__"